import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (sessionId) {
        try {
          await handleGoogleSession(sessionId);
          // Clear hash and navigate
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/dashboard', { replace: true });
        } catch (error) {
          window.history.replaceState(null, '', window.location.pathname);
          toast.error(error.response?.data?.detail || 'Google sign-in failed. Please try again.');
          navigate('/login', { replace: true });
        }
      } else {
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [handleGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-muted-foreground">{t('common.loading')}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
